// GENERATED FILE - DO NOT EDIT.
// Produced from the sibling .less file by packages/shared/theme/vars/lessToJs.js.
// Run `yarn workspace shared run gen:tokens` to regenerate.
module.exports = {
  "@sidebar-width": "240",
  "@font-family": "Lato, Helvetica Neue, Helvetica, Arial",
  "@heading-color": "rgba(0,0,0,0.65)",
  "@z-shadow-1": "0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.05)",
  "@layout-header-height": "75",
  "@layout-padding": "30px 50px 50px",
  "@max-single-column-width": "1100px"
}
